export default "__VITE_ASSET__B4wJ6rL9__"